import { ReactNode } from 'react';
import { Paper, Stack } from '@rossum/ui/material';

type ContentWrapperProps = {
  children: ReactNode;
};

export const ContentWrapper = ({ children }: ContentWrapperProps) => (
  <Stack component={Paper} direction="column" px={4} py={3} width={1}>
    {children}
  </Stack>
);
